const findSporterIdInList = (list, id) =>
  list.filter(sporterTest => sporterTest.id === id);

export default findSporterIdInList;
